import { getItemFromCollection } from "directus/src/operations";

export async function fetchJobDataForForm({ id }) {
  try {
    const query = {
      fields: [
        "id",
        "name",
        "status",
        "description",
        "start_date",
        "end_date",
        "margin_calculator_link",
        "project",
        "disable_job_logging",
        "type",
        "contract",
        { tags: ["id", { tag: ["id", "label"] }] },
        {
          coordinator: [
            "id",
            "first_name",
            "last_name",
            "avatar",
            "title",
            "department.name",
            "user.role.name",
          ],
        },
      ],
    };
    const response = await getItemFromCollection("jobs", id, query);
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
}

export async function fetchJobCoordinators({ id }) {
  try {
    const query = {
      fields: [
        "coordinator",
        "project.coordinator",
        "project.sales_coordinator",
      ],
    };
    const response = await getItemFromCollection("jobs", id, query);
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
}
